import type { CleInfo } from "./useInfos.js";
import { IconeExterne } from "./icones.js";
import * as s from "./infosStyles.js";

/**
 * La signature, commune au menu, à la feuille et aux crédits : « Made in Annecy with ♥ », la
 * phrase de réalisation (`chaines.json`, clés `info*`), et — selon `lien` — le lien texte du
 * menu. Le lien s'ouvre dans un nouvel onglet ; `surLien` laisse l'appelant arrêter la voix.
 */

export function Signature({
  t,
  lien,
  surLien,
  rolePourMenu = false,
}: {
  t: (cle: CleInfo) => string;
  lien: boolean;
  surLien: () => void;
  /** Dans le menu, le lien est une entrée comme les autres (↑ ↓). */
  rolePourMenu?: boolean;
}) {
  return (
    <div style={s.signature}>
      <span style={s.signatureFaite}>
        {t("infoSignature")} <span aria-hidden>♥</span>
      </span>
      <span style={s.signaturePar}>{t("infoRealise")}</span>
      {lien && (
        <a
          className="inf-lien"
          href={t("infoLienUrl")}
          target="_blank"
          rel="noopener"
          role={rolePourMenu ? "menuitem" : undefined}
          aria-label={t("infoLienAria")}
          onClick={surLien}
          style={s.lien}
        >
          {t("infoLienAffiche")}
          <IconeExterne taille={16} />
        </a>
      )}
    </div>
  );
}
